/**
 * Applies yellow highlight to form controls inside .vendor-amendment-review
 * without modifying vendor registration step components.
 */
const AmendmentHighlightStyles = ({ changedFields }) => {
  if (!changedFields || changedFields.size === 0) return null;

  const selectors = Array.from(changedFields)
    .map((name) => {
      const safe = String(name).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      return [
        `.vendor-amendment-review .MuiInputBase-root:has(input[name="${safe}"])`,
        `.vendor-amendment-review .MuiInputBase-root:has(textarea[name="${safe}"])`,
      ].join(",\n");
    })
    .join(",\n");

  return (
    <style>{`${selectors} { background-color: #fff9c4 !important; }`}</style>
  );
};

export default AmendmentHighlightStyles;
